<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <template v-if="groups.length === 0 && !loading">
      <center>No Activity Audit Data Available</center>
    </template>

    <div v-for="(group, gIdx) in groups" :key="`pg-${gIdx}-${group.key}`">
      <h3 style="margin-top: 30px; margin-bottom: 10px;">{{ group.key }}</h3>

      <div v-for="type in group.types" :key="`${gIdx}-${type.activityAuditTypeId}`" style="margin-top: 30px; margin-bottom: 20px;" class="activity-type-wrapper">
        <el-row :gutter="20">
          <el-col :span="16">
            <el-col :span="24">
              <table class="totalsTable hiaTable dashboard-table">
                <thead>
                  <tr>
                    <th>Activity Type</th>
                    <th class="textAlignRight" style="padding-right: 13px;">Total Number of Records</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="textAlignLeft">{{ type.name }}</td>
                    <td class="textAlignRight">{{ type.totalRecordsWithActivity }}</td>
                  </tr>
                </tbody>
              </table>
            </el-col>

            <el-col :span="24">
              <div style="margin-left: 20px; margin-top: 20px;">
                <table class="hiaTable">
                  <thead>
                    <tr>
                      <th style="width: 24%;">Coder</th>
                      <th>Total Records</th>
                      <th>Activity Frequency</th>
                      <th>Handled Correctly</th>
                      <th>Handled Incorrectly</th>
                      <th>Not Answered</th>
                      <th>Accuracy</th>
                    </tr>
                  </thead>
                  <tr v-for="(coder, idx) in type.coders" :key="idx">
                    <td class="textAlignLeft" style="width: 24%;">{{ coder.name }}</td>
                    <td>{{ coder.totalRecords }}</td>
                    <td>{{ coder.totalLogged }}</td>
                    <td>{{ coder.handledYes }}</td>
                    <td>{{ coder.handledNo }}</td>
                    <td>{{ coder.notAnswered }}</td>
                    <td>{{ formatPercentage(coder.accuracy) }}</td>
                  </tr>
                  <tr class="strong emphasis">
                    <td class="textAlignLeft">Total</td>
                    <td>{{ totalFor(type.coders, 'totalRecords') }}</td>
                    <td>{{ totalFor(type.coders, 'totalLogged') }}</td>
                    <td>{{ totalFor(type.coders, 'handledYes') }}</td>
                    <td>{{ totalFor(type.coders, 'handledNo') }}</td>
                    <td>{{ totalFor(type.coders, 'notAnswered') }}</td>
                    <td>{{ overallAccuracy(type.coders) }}</td>
                  </tr>
                </table>
              </div>
            </el-col>
          </el-col>

          <el-col :span="8" style="text-align: center; margin-top: 28px;">
            <ActivityAuditBarChart :chartId="`PRO_Printable_activityAuditByCoder_barchart_${gIdx}_${type.activityAuditTypeId}`" :typeName="type.name" :activities="type.coders" />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from '@/utilities/axios-global'
  import ActivityAuditBarChart from '@/views/reports/highcharts/activityAuditBarChart.vue'

  export default {
    name: 'PRO_ActivityAuditByCoderPrintable',
    components: { ActivityAuditBarChart },
    props: ['proRecordIds', 'codeTypes'],
    data() {
      return { loading: false, groups: [] }
    },
    methods: {
      async getData() {
        if (!this.tenantSetup || !this.tenantSetup.activityAuditsEnabled) {
          this.groups = []
          return
        }
        try {
          this.loading = true
          const response = await axios.post(`${this.baseApiUrl}/reports/activity-audit/summary-by-coder`, {
            recordType: 'PRO',
            recordIds: this.proRecordIds || '',
            codeTypeIds: this.codeTypes
          })
          this.groups = (response.data && response.data.groups) || []
        } catch (err) {
          this.groups = []
        } finally {
          this.loading = false
        }
      },
      formatPercentage(value) {
        if (value === null || value === undefined) return '-'
        return (value * 100).toFixed(2) + '%'
      },
      totalFor(coders, prop) {
        return (coders || []).reduce((s, c) => s + Number(c[prop] || 0), 0)
      },
      overallAccuracy(coders) {
        const yes = this.totalFor(coders, 'handledYes')
        const no = this.totalFor(coders, 'handledNo')
        const denom = yes + no
        return denom > 0 ? ((yes / denom) * 100).toFixed(2) + '%' : '-'
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl']),
      ...mapState('managedLists/tenantSetup/', ['tenantSetup'])
    },
    mounted: async function() {
      await this.getData()
    },
    activated: async function() {
      await this.getData()
    },
    watch: {
      proRecordIds: async function() {
        await this.getData()
      },
      codeTypes: {
        handler: async function() {
          await this.getData()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  .activity-type-wrapper + .activity-type-wrapper {
    margin-top: 60px !important;
  }

  .hiaTable thead th {
    text-align: center;
  }

  .hiaTable thead th:first-child {
    text-align: left;
  }

  .hiaTable tr td {
    text-align: right;
  }

  .hiaTable td.textAlignLeft {
    text-align: left;
  }

  .hiaTable tr:nth-child(even) {
    background-color: #fafafa;
  }

  .hiaTable thead tr,
  .hiaTable tr.strong.emphasis {
    background-color: #fff;
  }

  .totalsTable {
    border-spacing: 0px;
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }

  .textAlignRight {
    text-align: right !important;
    padding-right: 10px !important;
  }
</style>
